import { useState } from "react";
import { LoaderBoxCircular } from "../Components/LoaderBox";
import { Box, Container, TextField, Grid, Divider, Button, TableContainer, Table, TableHead, TableRow, TableCell, Paper, TableBody, Chip } from "@mui/material";
import { ArrowBack, FileDownload, Replay } from "@mui/icons-material";
import { ExportToCsv } from "export-to-csv";
import { DialogAlert } from "../Components/DialogAlert";
import { instance, validateFunction, functions } from "../Components/config";
import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "../Components/AuthContext";

function UPSE4Detalle() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state?.id;
  const esRevision = location.state?.validar ?? false;

  const [nombreU2, setNombreU2] = useState("");
  const [mes, setMes] = useState("");
  const [idMes, setIdMes] = useState("");
  const [fechaPresentacion, setFechaPresentacion] = useState("");
  const [fechaRevision, setFechaRevision] = useState("");
  const [tipoInforme, setTipoInforme] = useState("");
  const [anioMeta, setAnioMeta] = useState(0);
  const [idUpse2, setIdUpse2] = useState(0);
  const [responsable, setResponsable] = useState("");
  const [idResponsable, setIdResponsable] = useState("");
  const [idEncargado, setIdEncargado] = useState("");
  const [encargado, setEncargado] = useState("");
  const [estado, setEstado] = useState("");
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [tipoPlanificacion, setTipoPlanificacion] = useState("");

  const [accion, setAccion] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [listaDetalle, setListaDetalle] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/UPSE4",
    pageState: {},
  });

  function estadoColor(valor) {
    if (valor === "Aprobado") return "success";
    if (valor === "Rechazado") return "error";
    return "warning";
  }

  function getInfoUPSE() {
    if (id === undefined) {
      navigate("/UPSE4");
    }
    instance.get(`/upse4/listById/${id}`)
      .then((res) => {
        setNombreU2(res.data.nombreU2);
        setMes(res.data.mes);
        setIdMes(res.data.idMes);
        setFechaPresentacion(res.data.fechaPresentacion);
        setFechaRevision(res.data.fechaRevision);
        setTipoInforme(res.data.tipoInforme);
        setResponsable(res.data.creado);
        setIdResponsable(res.data.idCreado);
        setEncargado(res.data.responsable);
        setIdEncargado(res.data.idResponsable);
        setAnioMeta(res.data.anioMeta);
        setIdUpse2(res.data.idupse2);
        setEstado(res.data.estado);
        setMotivoRechazo(res.data.motivoRechazo);
        setTipoPlanificacion(res.data.tipoPlanificacion);
        setListaDetalle(res.data.detalle)
      })
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message });
        }
        setOpenDialog(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  if (isLoading) {
    getInfoUPSE();
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const comentario = e.target.comentario.value;

    if (accion === "3" && comentario.length === 0) {
      setDialog({
        title: "Aviso",
        text: "Si se va a rechazar el formulario, debe agregar la descripcion del motivo de rechazo u observaciones.",
      });
      setOpenDialog(true);
      return;
    }

    instance.post('upse4/registrarRevision', {
      id,
      motivo: comentario,
      idEstado: accion,
      idEncargado,
      idResponsable,
      anioMeta,
      idUpse2
    })
      .then(() => {
        setDialog({
          title: "Aviso",
          text: "Se ha registrado correctamente la revision.",
          redirect: true,
          page: "/UPSE4"
        });
      })
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message });
        }
      })
      .finally(() => {
        setOpenDialog(true);
      });
  };

  function parsearFecha(fecha) {
    if (!fecha) { return '-'; }
    const fechaFixed = new Date(fecha);
    const yyyy = fechaFixed.getFullYear();
    const MM = String(fechaFixed.getMonth() + 1).padStart(2, '0');
    const dd = String(fechaFixed.getDate()).padStart(2, '0');
    const HH = String(fechaFixed.getHours()).padStart(2, '0');
    const mm = String(fechaFixed.getMinutes()).padStart(2, '0');

    return `${yyyy}-${MM}-${dd} ${HH}:${mm}`;
  }

  const handleExportCsv = () => {
    const esSemillas = tipoPlanificacion === "semillas";
    const headers = esSemillas
      ? ["Subproducto", "Cultivo", "Cultivar", "Meta planificada", "Cantidad ejecutada", "Brecha", "Observaciones"]
      : ["Producto", "Meta planificada", "Cantidad ejecutada", "Brecha", "Beneficiarios", "Observaciones"];

    const rows = listaDetalle.map((item) => {
      const fila = esSemillas
        ? { Subproducto: item.subproducto, Cultivo: item.tipoCultivo, Cultivar: item.cultivar }
        : { Producto: item.producto };
      fila["Meta planificada"] = item.cantidadPlanificada;
      fila["Cantidad ejecutada"] = item.cantidadEjecutada;
      fila["Brecha"] = item.brecha;
      if (!esSemillas) fila["Beneficiarios"] = resumenBeneficiarios(item.beneficiarios);
      fila["Observaciones"] = item.observaciones || "";
      return fila;
    });

    const csvExporter = new ExportToCsv({
      filename: `REPORTE_UPSE4_${anioMeta}_${id}_${new Date().toISOString().slice(0, 10)}`,
      fieldSeparator: ";",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: false,
      headers
    });
    csvExporter.generateCsv(rows);
  };

  function resumenBeneficiarios(beneficiarios) {
    if (!beneficiarios || beneficiarios.length === 0) return '-';
    const grupos = beneficiarios.reduce((acc, b) => {
      if (!acc[b.grupo]) acc[b.grupo] = [];
      if (Number(b.cantidad) > 0) acc[b.grupo].push(`${b.nombre}=${b.cantidad}`);
      return acc;
    }, {});
    return Object.entries(grupos)
      .filter(([, valores]) => valores.length > 0)
      .map(([grupo, valores]) => `${grupo}: ${valores.join(', ')}`)
      .join(' | ') || '-';
  }

  return (
    <Container>
      <Box sx={{ marginTop: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)}>Volver</Button>
        <h2 style={{ textAlign: 'center', flex: 1, margin: 0 }}>Detalle de UPSE-4</h2>
        <Chip label={`U4-${id}`} size="small" color="primary" variant="outlined" />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <LoaderBoxCircular isLoading={isLoading}>
          <Box sx={{ width: '100%', maxWidth: '100%', paddingX: 3, marginBottom: 5 }}>
            <Box
              sx={{
                padding: "4px",
                margin: { xs: 0, sm: 1 },
                border: { xs: "0", sm: "1px solid #000" },
              }}
              component={"form"}
              onSubmit={handleSubmit}
            >
              <Grid
                container
                spacing={3}
                padding={2}
                rowSpacing={1}
                sx={{ alignItems: "center" }}
              >
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <h3 style={{ textAlign: 'center', margin: 0, marginRight: 8 }}>Datos generales</h3>
                  {estado && <Chip label={estado} color={estadoColor(estado)} />}
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="UPSE-2" value={nombreU2} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={3} marginTop={2}>
                  <TextField disabled fullWidth label="Mes" value={mes} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={3} marginTop={2}>
                  <TextField disabled fullWidth label="Tipo de informe" value={tipoInforme} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="Fecha de presentación" value={parsearFecha(fechaPresentacion)} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="Fecha de revisión" value={parsearFecha(fechaRevision)} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="Planificación" value={`U2-${idUpse2}`} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="Responsable" value={responsable} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="Encargado/a de revisión" value={encargado} InputLabelProps={{ shrink: true }} />
                </Grid>

                {motivoRechazo && (
                  <Grid item xs={12} marginTop={2}>
                    <TextField disabled fullWidth multiline label="Motivo de rechazo" value={motivoRechazo} InputLabelProps={{ shrink: true }} />
                  </Grid>
                )}

                {estado === "Rechazado" && idResponsable === user.id && validateFunction(user, functions.CreateUPSE4) && (
                  <Grid item xs={12} marginTop={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<Replay />}
                      onClick={() => navigate("/UPSE4Agregar", {
                        state: {
                          idUpse2: { Id: idUpse2, Nombre: nombreU2 },
                          mes: { Id: idMes, Nombre: mes }
                        }
                      })}
                    >
                      Corregir y reportar de nuevo
                    </Button>
                  </Grid>
                )}

                <Grid item xs={12} marginTop={3}>
                  <Divider variant="middle" component="aside" />
                </Grid>

                <Grid item xs={12} sm={12} marginTop={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                  <h3 style={{ margin: 0 }}>Detalle de productos reportados</h3>
                  {estado === "Aprobado" && (
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      startIcon={<FileDownload />}
                      onClick={handleExportCsv}
                    >
                      Exportar CSV
                    </Button>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <TableContainer component={Paper} sx={{ marginTop: 4, overflowX: "auto" }}>
                    <Table size="medium">
                      <TableHead>
                        <TableRow>
                          {tipoPlanificacion === "semillas" ? (
                            <>
                              <TableCell><strong>Subproducto</strong></TableCell>
                              <TableCell><strong>Cultivo</strong></TableCell>
                              <TableCell><strong>Cultivar</strong></TableCell>
                            </>
                          ) : (
                            <TableCell><strong>Producto</strong></TableCell>
                          )}
                          <TableCell><strong>Meta planificada</strong></TableCell>
                          <TableCell><strong>Cantidad ejecutada</strong></TableCell>
                          <TableCell><strong>Brecha</strong></TableCell>
                          {tipoPlanificacion !== "semillas" && <TableCell><strong>Beneficiarios</strong></TableCell>}
                          <TableCell><strong>Observaciones</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {listaDetalle.map((item, index) => (
                          <TableRow key={index}>
                            {tipoPlanificacion === "semillas" ? (
                              <>
                                <TableCell>{item.subproducto}</TableCell>
                                <TableCell>{item.tipoCultivo}</TableCell>
                                <TableCell>{item.cultivar}</TableCell>
                              </>
                            ) : (
                              <TableCell>{item.producto}</TableCell>
                            )}
                            <TableCell>{item.cantidadPlanificada}</TableCell>
                            <TableCell>{item.cantidadEjecutada}</TableCell>
                            <TableCell sx={{ color: Number(item.brecha) < 0 ? 'error.main' : 'inherit', fontWeight: Number(item.brecha) < 0 ? 'bold' : 'normal' }}>
                              {item.brecha}
                            </TableCell>
                            {tipoPlanificacion !== "semillas" && <TableCell>{resumenBeneficiarios(item.beneficiarios)}</TableCell>}
                            <TableCell>{item.observaciones || '-'}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>


                {(esRevision && validateFunction(user, functions.ReviewUPSE4)) &&
                  <>
                    <Grid item sm={1} marginTop={3} />
                    <Grid item xs={12} sm={10} marginTop={3}>
                      <TextField
                        fullWidth
                        label="Comentarios u observaciones"
                        id="comentario"
                        name="comentario"
                        type="text"
                        multiline
                        inputProps={{ maxLength: 1000 }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item sm={1} marginTop={3} />

                    <Grid item sm={3} />
                    <Grid item xs={12} sm={3}>
                      <Button
                        color="error" fullWidth variant="contained" type="submit" onClick={() => setAccion("3")}>Rechazar</Button>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Button
                        fullWidth variant="contained" type="submit" onClick={() => setAccion("2")}>Aprobar</Button>
                    </Grid>
                    <Grid item sm={3} />
                  </>}

              </Grid>
            </Box>
          </Box>
        </LoaderBoxCircular>

        <DialogAlert
          title={dialog.title}
          text={dialog.text}
          open={openDialog}
          setOpen={setOpenDialog}
          redirectOnClose={dialog.redirect}
          page={dialog.page}
          pageState={dialog.pageState}
        />
      </Box>
    </Container>

  );
}

export { UPSE4Detalle };
